import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { isAxiosError } from "axios";
import {
  clearAuthSession,
  refreshAccessToken,
  setAccessToken,
} from "../../../utils/auth";

interface AuthState {
  username: string | undefined;
  user: any;
  token: string | null;
}

const initialState: AuthState = {
  username: undefined,
  user: null,
  token: null,
};

// Async thunk to refresh the token
export const refreshToken = createAsyncThunk(
  "auth/refreshToken",
  async (_, { rejectWithValue }) => {
    try {
      const newToken = await refreshAccessToken();
      return newToken;
    } catch (error) {
      if (isAxiosError(error) && error.response) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error);
      }
    }
  },
);
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    reset: () => initialState,
    setCredentials: (state, action) => {
      const { user, accessToken } = action.payload;
      state.user = user;
      state.token = accessToken;
      setAccessToken(accessToken);
    },
    logOut: (state) => {
      state.user = null;
      state.token = null;
      clearAuthSession();
    },
    setUserName: (state, action) => {
      state.username = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(refreshToken.fulfilled, (state, action) => {
      state.token = action.payload;
      setAccessToken(action.payload);
    });
    builder.addCase(refreshToken.rejected, (state, action) => {
      state.token = null;
      clearAuthSession();
    });
  },
});


export const  {setCredentials, logOut, reset, setUserName} = authSlice.actions;


export default authSlice.reducer;

export const seleceCurrentUser = (state: RootState) => state.auth.user;
export const seleceCurrentToken = (state: RootState) => state.auth.token;
